import { render, staticRenderFns } from "./ipsecurity.vue?vue&type=template&id=22b6aca4&scoped=true&"
import script from "./ipsecurity.vue?vue&type=script&lang=js&"
export * from "./ipsecurity.vue?vue&type=script&lang=js&"
import style0 from "./ipsecurity.vue?vue&type=style&index=0&id=22b6aca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6aca4",
  null
  
)

export default component.exports